<div
  class="flex items-center justify-between p-3 bg-slate-50 rounded-lg hover:bg-slate-100 transition-colors border border-slate-100"
>
  <div class="flex items-center gap-3 flex-1">
    <div class="text-lg font-bold text-slate-400 w-8">{{ item().index }}</div>
    <div class="flex-1">
      <p class="font-semibold text-slate-900 text-sm">{{ item().titulo }}</p>
      @if (item().subtitulo) {
        <p class="text-xs text-slate-500">{{ item().subtitulo }}</p>
      }
    </div>
  </div>
  <div class="text-left">
    <p class="font-bold text-slate-900">
      {{ item().tipo === 'moneda' ? (item().valor | currency: 'PEN' : 'S/. ') : item().valor }}
    </p>
    <div class="w-16 h-1 bg-slate-200 rounded-full mt-1">
      <div
        class="h-full bg-linear-to-r rounded-full"
        [style.width.%]="calcularPorcentaje()"
        [ngClass]="{
          'from-emerald-500 to-emerald-400': item().color === 'green',
          'from-blue-500 to-blue-400': item().color === 'blue',
          'from-yellow-500 to-yellow-400': item().color === 'yellow',
          'from-red-500 to-red-400': item().color === 'red',
          'from-purple-500 to-purple-400': item().color === 'purple',
        }"
      ></div>
    </div>
  </div>
</div>
